import API_BASE_URL from '../Config';

export const getRangosAntiguedadPaginados = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/rangos-antiguedad/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url.toString(), {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar rangos de antigüedad paginados');
    return response.json();
};

export const getRangoAntiguedadById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/rangos-antiguedad/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el rango de antigüedad');
    return response.json();
};

export const createRangoAntiguedad = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/rangos-antiguedad`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el rango de antigüedad');
    return response.json();
};

export const updateRangoAntiguedad = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/rangos-antiguedad/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el rango de antigüedad');
    return response.json();
};

export const darDeBajaRangoAntiguedad = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/rangos-antiguedad/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja el rango de antigüedad');
};
